import { defineComponent, ref, watchEffect, watch } from 'vue'
import { get } from 'lodash'
const SearchItemTitle = function (attr) {
  return <>{attr.title ? <div class="search_item__title">{attr.title}</div> : null}</>
}

const SearchItemComponent = defineComponent({
  props: {
    title: String,
    label: [String, Number],
    value: [String, Number],
    index: Number,
    data: Object,
    show: {
      default: true,
      type: [Boolean]
    },
    options: {
      default: () => [],
      type: Array
    }
  },
  emits: ['update:value', 'update:label', 'updateChild'],
  setup(props, { expose, emit }) {
    emit('update:value', props.value || get(props, 'options[0].id', ''))
    watch(
      () => props.value,
      () => {
        if (!props.value) return
        let curActiveItem = (props.options as any).find((item: any) => item.id === props.value)
        console.log('curActiveItem===>', props.value, props.index, curActiveItem)
        emit('update:label', get(curActiveItem, 'name', ''))
        console.log(curActiveItem)
        if (Object.keys(get(curActiveItem, 'childList', {})).length) {
          emit('updateChild', curActiveItem.childList, props.index)
        }
      },
      {
        immediate: true
      }
    )
    // watch(
    //   () => props.data,
    //   (val) => {
    //     console.log('data', val, props.options)
    //     let curActiveItem = (props.options as any).find((item: any) => item.name === props.label)
    //     console.log(curActiveItem, props.index)
    //     if (Object.keys(get(curActiveItem, 'childList', {})).length) {
    //       emit('updateChild', curActiveItem.childList, props.index)
    //     }
    //   },
    //   {
    //     deep: true
    //   }
    // )
    watch(
      () => props.options,
      () => {
        let curActiveItem = (props.options as any).find((item: any) => item.name === props.label)
        let curVal = curActiveItem ? curActiveItem.id : get(props, 'options[0].id', '')
        emit('update:value', curVal)
        emit(
          'update:label',
          get(
            (props.options as any).find((item: any) => item.id === curVal),
            'name',
            ''
          )
        )
        if (Object.keys(get(curActiveItem, 'childList', {})).length) {
          emit('updateChild', curActiveItem.childList, props.index)
        }
      },
      {
        deep: true
      }
    )
    return () => {
      let options = get(props, 'options', [])
      return (
        <>
          <div
            class="search_item"
            style={{
              display: props.show ? 'block' : 'none'
            }}
          >
            <SearchItemTitle title={props.title}></SearchItemTitle>
            <div class="opt_wrap">
              {options.map((item) => {
                return (
                  <div
                    class={`opt ${props.value === item.id ? 'active' : null}`}
                    onClick={function () {
                      //   current.value = item.id
                      emit('update:value', item.id)
                    }}
                  >
                    {item.name}
                  </div>
                )
              })}
            </div>
          </div>
        </>
      )
    }
  }
})

export default SearchItemComponent
